import React, { useEffect, useState } from "react";
import axios from "axios";
import { CircularProgress, Typography, Box, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import config from "../Config/config"; // 👈 import your config file

const UnsubscribePage = () => {
  const [status, setStatus] = useState("loading");
  const [email, setEmail] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const emailParam = params.get("email");
    if (!emailParam) {
      setStatus("error");
      return;
    }

    setEmail(emailParam);
    unsubscribe(emailParam);
  }, []);

  const unsubscribe = async (emailParam) => {
    try {
      await axios.post(`${config.API_BASE_URL}/unsubscribe`, { email: emailParam });
      setStatus("success");
    } catch (error) {
      console.error("Unsubscribe failed:", error);
      setStatus("error");
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      sx={{ backgroundColor: "#f7f7fb", textAlign: "center", padding: 3 }}
    >
      {status === "loading" && (
        <>
          <CircularProgress sx={{ color: "#333999", mb: 2 }} />
          <Typography variant="h6" sx={{ color: "#333999" }}>
            Processing your unsubscribe request...
          </Typography>
        </>
      )}

      {status === "success" && (
        <>
          <CheckCircleIcon sx={{ color: "#333999", fontSize: 60, mb: 2 }} />
          <Typography variant="h5" sx={{ color: "#333999", fontWeight: 600 }}>
            You’ve been unsubscribed successfully!
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            {email && `Email: ${email}`}
          </Typography>
          <Button
            variant="contained"
            sx={{
              mt: 3,
              backgroundColor: "#333999",
              "&:hover": { backgroundColor: "#2a287a" },
            }}
            href="https://www.explorer.listernaut.com"
          >
            Back to Home
          </Button>
        </>
      )}

      {status === "error" && (
        <>
          <ErrorIcon sx={{ color: "red", fontSize: 60, mb: 2 }} />
          <Typography variant="h5" sx={{ color: "#333999", fontWeight: 600 }}>
            Oops! Something went wrong.
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            Please check your unsubscribe link or contact support.
          </Typography>
        </>
      )}
    </Box>
  );
};

export default UnsubscribePage;